import DOMReady from '../utils/DOMReady'

// Include css for webpack (for development only)
const css = require('../../css/blocks/accordion.scss') // eslint-disable-line no-unused-vars

class Accordion {
  /**
   * Constructor
   *
   * @param {Element} el HTML element
   */
  constructor(el) {
    this.wrapper = el
    this.items = Array.from(this.wrapper.querySelectorAll('.accordion__item'))

    if (this.items.length) {
      this.init()
    }
  }

  reset() {
    this.items.forEach(item => {
      const description = item.querySelector('.accordion__item__description')
      item.classList.remove('accordion__item--active')
      description.removeAttribute('style')
    })
  }

  open(item) {
    const description = item.querySelector('.accordion__item__description')
    item.classList.add('accordion__item--active')
    description.style.height = `${description.scrollHeight}px`
  }

  init() {
    this.items.forEach((item, index) => {
      const toggle = item.querySelector('.accordion__item__toggle')

      if (index === 0) {
        this.open(item)
      }

      if (toggle) {
        toggle.addEventListener('click', e => {
          e.preventDefault()
          const isActive = item.classList.contains('accordion__item--active')
          this.reset()
          if (!isActive) this.open(item)
          e.stopPropagation()
        })
      }
    })
  }
}

DOMReady(() => {
  const wrapperEl = document.querySelectorAll('.accordion')
  Array.from(wrapperEl).forEach(el => {
    // eslint-disable-next-line no-new
    new Accordion(el)
  })
})
